var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FlotoModule',[(_vm.hasPermission)?[_c('RouterView',{key:_vm.$route.fullPath})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }